import { KeyboardShortcutName } from '../../../cross-team-shared/misc-services/keyboard-shortcut.service';

export const translationShortcuts = [
  'nudgeUp',
  'nudgeDown',
  'nudgeLeft',
  'nudgeRight',
  'nudgeInwards',
  'nudgeOutwards',
  'nudgeUpSlow',
  'nudgeDownSlow',
  'nudgeLeftSlow',
  'nudgeRightSlow',
  'nudgeInwardsSlow',
  'nudgeOutwardsSlow',
] as const;

export const rotationShortcuts = [
  'yawLeft',
  'yawRight',
  'pitchLeft',
  'pitchRight',
  'rollLeft',
  'rollRight',
  'yawLeftSlow',
  'yawRightSlow',
  'pitchLeftSlow',
  'pitchRightSlow',
  'rollLeftSlow',
  'rollRightSlow',
] as const;

export const resizeShortcuts = [
  'contractDown',
  'contractLeft',
  'contractHeight',
  'expandRight',
  'expandUp',
  'expandHeight',
  'contractDownSlow',
  'contractLeftSlow',
  'contractHeightSlow',
  'expandRightSlow',
  'expandUpSlow',
  'expandHeightSlow',
] as const;

export const outputShortcuts: KeyboardShortcutName[] = [
  'cycleViewMode',
  'decreaseOpacity',
  'increaseOpacity',
  'redraw',
  'resetSensorView',
  'selectCuboidTool',
  'selectEditTool',
  'selectMeasureTool',
  'selectSelectTool',
  'toggle3DShortcuts',
  'toggleInspectMode',
  'shiftDown',
  'shiftUp',
  ...translationShortcuts,
  ...rotationShortcuts,
  ...resizeShortcuts,
];
